if (!customElements.get('sticky-cart-button')) {
  customElements.define(
    'sticky-cart-button',
    class StickyCartButton extends HTMLElement {
      constructor() {
        super();
        this.stickyButtonId = 'sticky-cart-button';
        this.observer = null;
      }

      connectedCallback() {
        const productName = this.getAttribute('data-product-title') || '';
        const addToCartText = this.getAttribute('data-add-to-cart-text') || 'Add to Cart';
        const productImage = this.getAttribute('data-product-image') || '';
        const colorScheme = this.getAttribute('data-color-scheme');

        document.getElementById(this.stickyButtonId)?.remove();

        const stickyBar = document.createElement('div');
        stickyBar.id = this.stickyButtonId;
        stickyBar.className = 'sticky-cart-bar hide';
        if (colorScheme) stickyBar.classList.add(`color-${colorScheme}`);

        const imageMarkup = productImage ? `<span class="sticky-cart-bar__product-image-wrapper"><img class="sticky-cart-bar__product-image" src="${productImage}" alt="${productName}"/></span>` : '';

        stickyBar.innerHTML = `
          <div class="sticky-cart-bar__content">
            <div class="sticky-cart-bar__inner page-width">
              <div class="sticky-cart-bar__product-info">
                ${imageMarkup}
                <span class="sticky-cart-bar__product-name">${productName}</span>
              </div>
              <button class="sticky-cart-bar__add-to-cart button button--full-width button--primary button--icon button--small" aria-label="${addToCartText}">
                ${addToCartText}
                <span class="icon--svg">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="18 15 12 9 6 15"></polyline>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        `;

        document.body.insertBefore(stickyBar, document.body.firstChild);
        stickyBar.setAttribute('aria-hidden', 'true');
        stickyBar.setAttribute('inert', '');

        stickyBar.querySelector('.sticky-cart-bar__add-to-cart')?.addEventListener('click', (e) => {
          e.preventDefault();
          let targetClass = this.getAttribute('data-target-class') || 'product-form__buttons';
          if (!targetClass.startsWith('.')) targetClass = '.' + targetClass;
          const productInfo = document.querySelector(targetClass);
          if (productInfo) {
            window.scrollTo({
              top: productInfo.getBoundingClientRect().bottom + window.pageYOffset - (window.innerHeight - 20),
              behavior: 'smooth',
            });
          }
        });

        // Determine the target class for scroll/visibility logic
        let targetClass = this.getAttribute('data-target-class') || 'product__info-container';
        // Ensure it starts with a dot
        if (!targetClass.startsWith('.')) targetClass = '.' + targetClass;

        const productInfo = document.querySelector(targetClass);
        if (!productInfo) return;
        const setVisible = (visible) => {
          stickyBar.classList.toggle('show', visible);
          stickyBar.classList.toggle('hide', !visible);
          stickyBar.toggleAttribute('inert', !visible);
          stickyBar.setAttribute('aria-hidden', String(!visible));
        };

        this.observer?.disconnect();
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);

        // "Show from": an id or class typed in the editor. The bar appears once
        // the visitor has scrolled into that element and stays for the rest of
        // the page, hiding only while the target (the buy buttons) is on screen.
        const showFromEl = this.findShowFrom(this.getAttribute('data-show-from'));
        if (showFromEl) {
          let ticking = false;
          const update = () => {
            ticking = false;
            const viewport = window.innerHeight;
            const started = showFromEl.getBoundingClientRect().top <= viewport * 0.6;
            const target = productInfo.getBoundingClientRect();
            const targetOnScreen = target.bottom > 0 && target.top < viewport;
            setVisible(started && !targetOnScreen);
          };
          this.onScroll = () => {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(update);
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          update();
          return;
        }

        this.observer = new IntersectionObserver(
          ([entry]) => {
            // IO tells us if ANY part of productInfo is visible.
            // We need its bottom relative to viewport.
            const bottom = entry.boundingClientRect.bottom;
            setVisible(bottom <= 0);
          },
          { threshold: 0 }
        );

        this.observer.observe(productInfo);
      }

      // Accepts "claims", "#claims" or ".usp-section": an id first, then a class.
      findShowFrom(value) {
        const name = (value || '').trim();
        if (!name) return null;
        try {
          if (name.startsWith('#') || name.startsWith('.')) return document.querySelector(name);
          return document.getElementById(name) || document.querySelector('.' + CSS.escape(name));
        } catch (error) {
          return null;
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.onScroll) {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
      }
    }
  );
}
